import { PListOrderDto } from '../../../../services/plistOrderService';

/**
 * TW 36430010: samleplukk — én av ordrene på plukklista eier lastbærer, kollilinjer,
 * tilleggslinjer og H1-totalene (kolli/vekt/frakt/paller). Regelen bestemmes av backend
 * (PListOrderRepository.GetOwnerOrderNoAsync) og kommer som isOwner på ordrene.
 */

/**
 * Plukklista avsluttes som én samlet sending med eierordre når alle ordrene skal til samme sted:
 * samme gateadresse, postnummer og land. Mottakernavnet teller ikke — hos Haucon kan samme
 * byggeplass ha «… AVD 2» i navnet. Ulik adresse (Ariens/Demanor i live) og batch-lister
 * (flere kunder samlet for plukking) sendes per ordre, som før.
 */
const normalize = (value?: string | null) => (value || '').trim().replace(/\s+/g, ' ').toUpperCase();

const addressKey = (o: PListOrderDto) =>
  [normalize(o.delAddress1), normalize(o.delPostNo).replace(/\s/g, ''), normalize(o.delCountry)].join('|');

export const isConsolidatedShipment = (orders: PListOrderDto[], isBatch?: boolean | null): boolean => {
  if (orders.length <= 1 || isBatch) return false;
  const first = addressKey(orders[0]);
  return orders.every(o => addressKey(o) === first);
};

/** Eierordren: flagget fra backend, ellers laveste ordrenummer. Null når lista er tom. */
export const resolveOwnerOrderNo = (orders: PListOrderDto[]): number | null => {
  if (orders.length === 0) return null;
  const flagged = orders.find(o => o.isOwner);
  if (flagged) return flagged.orderNo;
  return orders.reduce((min, o) => (o.orderNo < min ? o.orderNo : min), orders[0].orderNo);
};
